/* LeidingDeal BTW-toggle (global)
   Synchroniseert incl/excl BTW weergave tussen PDP, productkaart en cart.
   State: localStorage.ld_btw = 'incl' | 'excl' (default 'incl') */
(function () {
  'use strict';
  var KEY = 'ld_btw';
  var state = localStorage.getItem(KEY) || 'incl';

  function format(cents) {
    var n = Math.round(cents) / 100;
    var r=n.toFixed(2).split('.');r[0]=r[0].replace(/\B(?=(\d{3})+(?!\d))/g,'.');return '€ '+r[0]+','+r[1];
  }

  function applyState() {
    // Update elke [data-btw-incl]/[data-btw-excl] element (productkaart + cart)
    document.querySelectorAll('[data-btw-incl]').forEach(function (el) {
      var incl = parseFloat(el.dataset.btwIncl);
      var excl = parseFloat(el.dataset.btwExcl);
      if (isNaN(incl) || isNaN(excl)) return;
      el.textContent = state === 'excl' ? format(excl) : format(incl);
      el.setAttribute('title', state === 'excl' ? 'Excl. BTW' : 'Incl. BTW');
    });
    // PDP heeft eigen #ld-price / #ld-price-alt — sync state
    var pdpPrice = document.getElementById('ld-price');
    var pdpAlt = document.getElementById('ld-price-alt');
    var pdpToggle = document.getElementById('ld-btw-toggle');
    if (pdpPrice && pdpPrice.dataset.incl && pdpPrice.dataset.excl) {
      var incl = parseFloat(pdpPrice.dataset.incl);
      var excl = parseFloat(pdpPrice.dataset.excl);
      if (state === 'excl') {
        pdpPrice.textContent = format(excl);
        if (pdpAlt) pdpAlt.textContent = '(' + format(incl) + ' incl. btw)';
        if (pdpToggle) pdpToggle.textContent = 'excl. btw';
      } else {
        pdpPrice.textContent = format(incl);
        if (pdpAlt) pdpAlt.textContent = '(' + format(excl) + ' excl. btw)';
        if (pdpToggle) pdpToggle.textContent = 'incl. btw';
      }
    }
    // Label update op alle [data-btw-label] elementen
    document.querySelectorAll('[data-btw-label]').forEach(function (el) {
      el.textContent = state === 'excl' ? 'excl. BTW' : 'incl. BTW';
    });
    // Active-knop styling op globale toggle buttons
    document.querySelectorAll('[data-btw-toggle]').forEach(function (btn) {
      var target = btn.dataset.btwToggle;
      btn.classList.toggle('ld-btw-active', target === state);
      btn.setAttribute('aria-pressed', target === state ? 'true' : 'false');
    });
  }

  function toggle(newState) {
    state = newState === 'excl' ? 'excl' : 'incl';
    localStorage.setItem(KEY, state);
    applyState();
    document.dispatchEvent(new CustomEvent('ld:btw-changed', { detail: { state: state } }));
  }

  // Click handler — delegated (globale toggle + PDP toggle)
  document.addEventListener('click', function (e) {
    // Global toggle buttons
    var btn = e.target.closest('[data-btw-toggle]');
    if (btn) {
      e.preventDefault();
      toggle(btn.dataset.btwToggle);
      return;
    }
    // PDP toggle button
    if (e.target.id === 'ld-btw-toggle') {
      e.preventDefault();
      toggle(state === 'incl' ? 'excl' : 'incl');
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyState);
  } else {
    applyState();
  }
  // Re-apply op Shopify cart/section updates
  document.addEventListener('shopify:section:load', applyState);
})();
